import type { IconSvgObject } from './types';

const GalleryVerticalIcon: IconSvgObject = [
  ["path", { d: "M6 22L18 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 18L20 18", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 4L3 12C3 13.1046 3.89543 14 5 14L19 14C20.1046 14 21 13.1046 21 12V4C21 2.89543 20.1046 2 19 2L5 2C3.89543 2 3 2.89543 3 4Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryVerticalIcon;
